import { IVehicleCreateOptionsState } from '../../../types'
import { IVehicleActions } from '../../actions/vehicles'
import * as constants from '../../constants'

const vehiclesState: IVehicleCreateOptionsState = {
  isItemsFetching: false,
  carTypes: [],
  colors: [],
  makes: [],
  accommodations: []
}

export function vehicleCreateOptions(
  state: IVehicleCreateOptionsState = vehiclesState,
  action: IVehicleActions
): IVehicleCreateOptionsState {
  switch (action.type) {
    case constants.GET_VEHICLE_CREATE_OPTIONS_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.GET_VEHICLE_CREATE_OPTIONS_SUCCESS:
      const payload = action.payload
      return Object.assign({}, state, {
        isItemsFetching: false,
        ...payload
      })
    case constants.GET_VEHICLE_CREATE_OPTIONS_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })

    case constants.CREATE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.GET_VEHICLE_CREATE_ACCOMODATIONS_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.GET_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false,
        accommodations: Object.assign([], action.payload)
      })
    case constants.GET_VEHICLE_CREATE_ACCOMODATIONS_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })

    case constants.CREATE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.CREATE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.CREATE_VEHICLE_CREATE_ACCOMODATIONS_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })

    case constants.REMOVE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST:
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    case constants.REMOVE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS:
      return Object.assign({}, state, {
        isItemsFetching: false
      })
    case constants.REMOVE_VEHICLE_CREATE_ACCOMODATIONS_FAIL:
      return Object.assign({}, state, {
        isItemsFetching: false
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/vehicles/vehicle-create-options.ts